import * as yup from "yup"

export const schemaValidationPresaleItems = yup.object().shape({
  status: yup.string().required("required-field"),
  items: yup
    .array()
    .min(1, "you-must-enter-at-least-1-item")
    .required("required-field")
    .typeError("you-must-enter-at-least-one-value"),
  initDate: yup.string().required("required-field"),
  endDate: yup.string().required("required-field"),
  baseScheduleDate: yup.string().required("required-field"),
  stockDate: yup.string().required("required-field"),
  channel: yup
    .array(yup.string())
    .min(1, "you-must-enter-at-least-1-channel")
    .required("required-field")
    .typeError("you-must-enter-at-least-one-value"),
})

const schemaValidationItems = yup.object().shape({
  sku: yup.string().required("required-field"),
  name: yup.string().required("required-field"),
  safety: yup.number(),
  storePickup: yup.boolean(),
  enabled: yup.boolean(),
  categories: yup.string(),
  barcodes: yup.string(),
  logisticAttributes: yup.object().shape({
    volume: yup.number(),
  }),
  custom: yup.array(
    yup.object().shape({
      key: yup.string().required("required-field"),
      type: yup.string().required("required-field"),
      value: yup.mixed().required("required-field"),
    }),
  ),
})

export default schemaValidationItems
